// Module
var code = `<breadcrumbs></breadcrumbs>
<section class="box">
  <sub-header label="\$ctrl.headerLabel" header="\$ctrl.headerTitle"></sub-header>

  <ng-transclude></ng-transclude>
</section>`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/administration/prints/prints-page.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;